export default function Awards() {

    return (
        <>
            <div className="awards">
                <img className="thirty-years-ribbon" src={require('../../../assets/awards/thirty-years-ribbon.png')} alt="thirty-years-ribbon" />
                <img className="direct-ribbon" src={require('../../../assets/awards/direct-ribbon.png')} alt="direct-ribbon" />
            </div>
        </>
    )
}